<br>
<div class="row" style="width: 100%;text-align: center;">
    <div class="col-6 col-md-4" *ngFor="let f of dataFacilidades">
        <img src="assets/img/{{ f.IMG }}">
        <p>{{ f.DESC }}</p>
    </div>
</div>